import React from 'react';
import PropTypes from 'prop-types';
import uuidv4 from 'uuid';

//material ui:
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import { Tooltip, Fade } from '@material-ui/core';

//component:
import IntNumberFormatInput from '../../components/int_number_input_formatter';


const styles = theme => ({
    root: {
        height: '100%',
        width: 240,
    },
    containerPair: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        minWidth: 520,
        margin: '8px 0'
    },
    formControl: {
        display: 'flex',
        justifyContent: 'center',
        margin: '5px 25px',
        minWidth: 120,
        height: 72,
        width: 185,
    },
    buttonsContainer: {
        marginTop: 35,
        marginLeft: 25,
    },
    buttonsBottom: {
        marginRight: 15,
        padding: '10px 20px',
        marginBottom: 20,
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
    },
    inputImporte: {
        textAlign: 'right',
    },
    tooltip: {
        fontSize: 14,
        color: "white",
        backgroundColor: '#3a3434',
        fontWeight: 200,
    },
});

class EditArcadeGrid extends React.Component {

    constructor(props) {
        super(props);

        this.state = {

            id: this.props.lectura.id ? this.props.lectura.id : uuidv4(),
            contadorIni: this.props.lectura.contadorIni ? this.props.lectura.contadorIni : 0,
            contadorFin: this.props.lectura.contadorFin ? this.props.lectura.contadorFin : 0,
            regInterno: this.props.lectura.regInterno ? this.props.lectura.regInterno : '',
            comentario: this.props.lectura.comentario ? this.props.lectura.comentario : '',
        };
    };

    handleValueChange = (event, field) => {
        this.setState({ ...this.state, [field]: event.target.value });
    };

    render() {
        const { classes } = this.props;

        return (
            <div className={classes.root}>

                <div className={classes.containerPair}>
                    <FormControl className={classes.formControl}>
                        <TextField
                            id={'regInterno'}
                            label={'Registro interno'}
                            placeholder={'Registro interno'}
                            defaultValue={this.state.regInterno}
                            disabled
                        />
                    </FormControl>
                    <Tooltip title="Valor inicial del contador" TransitionComponent={Fade} TransitionProps={{ timeout: 600 }} classes={{tooltip: this.props.classes.tooltip}}>
                        <FormControl className={classes.formControl}>
                            <TextField
                                id={'contadorIni'}
                                label={'Contador Ini'}
                                placeholder={'Contador Ini'}
                                defaultValue={this.state.contadorIni}
                                InputProps={{ classes: { input: classes.inputImporte }, inputComponent: IntNumberFormatInput }}
                                disabled
                            />
                        </FormControl>
                    </Tooltip>
                </div>

                <div className={classes.containerPair}>
                    <Tooltip title="Valor del contador en esta fecha" TransitionComponent={Fade} TransitionProps={{ timeout: 600 }} classes={{tooltip: this.props.classes.tooltip}}>
                        <FormControl className={classes.formControl}>
                            <TextField
                                id={'contadorFin'}
                                label={'Contador Fin'}
                                placeholder={'Contador Fin'}
                                value={this.state.contadorFin}
                                InputProps={{ classes: { input: classes.inputImporte }, inputComponent: IntNumberFormatInput }}
                                onChange={(event) => this.handleValueChange(event, 'contadorFin')}
                            />
                        </FormControl>
                    </Tooltip>

                    <FormControl className={classes.formControl}>
                        <TextField
                            id={'comentario'}
                            label={'Comentario'}
                            placeholder={'Comentario'}
                            value={this.state.comentario}
                            onChange={(event) => this.handleValueChange(event, 'comentario')}
                        />
                    </FormControl>
                </div>
                <div className={classes.buttonsContainer}>
                    <Button className={classes.buttonsBottom} variant="contained" color="secondary" onClick={() => this.props.hideDialog()}>Cerrar</Button>
                    <Button className={classes.buttonsBottom} variant="contained" color="primary" onClick={() => {
                        const lectura = {
                            ...this.props.lectura,
                            contadorFin: this.state.contadorFin,
                            comentario: this.state.comentario,
                            usuario: this.props.usuario
                        }

                        if (this.props.checkValues(lectura)) {

                            this.props.okHandler(lectura);
                            this.props.hideDialog();
                        };
                    }
                    }>Guardar</Button>
                </div>

            </div>
        );

    };


};

EditArcadeGrid.propTypes = {
    lectura: PropTypes.object,
    okHandler: PropTypes.func.isRequired,
    checkValues: PropTypes.func.isRequired,
    usuario: PropTypes.number.isRequired,
    hideDialog: PropTypes.func.isRequired,
};


export default withStyles(styles, { withTheme: true })(EditArcadeGrid);